//angular
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
//app data
import { DateFormatValues, GridColumnsSection, OpacityState, PaymentRunStatus } from 'src/app/app.data';
//app models & Interfaces
import { CompanyTimezone, InvoiceObject, RestResponse, PaymentRunOperation, CompanyCurrency } from 'src/app/_shared/models';
//app services
import { DataSharingService, GridService, LoaderService, SkeletonLoaderService } from 'src/app/_core/services';
//others
import { Subscription } from 'rxjs';
import * as dayjs from 'dayjs';
import * as duration from 'dayjs/plugin/duration';
dayjs.extend(duration)
import * as relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime)
import { SettingsService } from '../../../_services/api/settings.service';
import { HttpParamsInterface } from 'src/app/_shared/interfaces/http-params.interface';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
import {DialogConfirmationComponent} from "../../../../_shared/dialog/confirmation/confirmation.component";
import {KeyName} from "../../../../../../app.keynames";
import {MatDialog} from "@angular/material/dialog";

@Component({
  providers: [GridService],
  selector: 'app-grid-payment-run-history',
  templateUrl: './grid-payment-run-history.component.html'
})

export class GridPaymentRunHistoryComponent implements OnInit, OnDestroy {
  collectionOfPaymentRun: Array<PaymentRunOperation> = [];
  companyCurrencyBase: CompanyCurrency;
  companyTimezone: CompanyTimezone;
  gridBulkSection: boolean = false;
  gridColumnsParam: string = GridColumnsSection.invoices;
  gridFilter: boolean = false;
  gridPanelPreferences: boolean = false;
  gridSearch: boolean = false;
  gridSectionMessage: boolean = false;
  subscriptionToCurrencyBase: Subscription;
  subscriptionToTimezone: Subscription;
  private subs = new Unsubscriber();
  gridName = "Payment Run History";

  @Input() _dateFormatValues = DateFormatValues;
  @Input() _paymentRunStatus = PaymentRunStatus;

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _loader: LoaderService,
    private _sanitizer: DomSanitizer,
    private _shareData: DataSharingService,
    public _grid: GridService,
    public _meta: MetaService,
    private settingsService: SettingsService,
    public _skeleton: SkeletonLoaderService,
    private _dialog: MatDialog,
  ) {
    this._iconRegistry.addSvgIcon('ico-actions', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-actions-01.svg'));
    this._iconRegistry.addSvgIcon("ico-run", this._sanitizer.bypassSecurityTrustResourceUrl("assets/svg/ico-rocket-01.svg"));
    this._iconRegistry.addSvgIcon("ico-schedule",this._sanitizer.bypassSecurityTrustResourceUrl("assets/svg/ico-subscriptions-01.svg"));

    this._grid.orderBy = 'targetDate';
    this._grid.sortBy = 'DESC';
    this._grid.itemsPerPage = 10;
  }

  getPaymentOperations() {
    const httpParams: HttpParamsInterface = {
      orderBy: this._grid.orderBy,
      sortBy: this._grid.sortBy,
      pageNo: this._grid.currentPageNumber,
      itemPerPage: this._grid.itemsPerPage,
    }

    this.subs.addSub = this.settingsService.getPaymentOperations(httpParams, true).subscribe(
      (res: RestResponse) => {
        this._grid.currentPageNumber = res.currentPageNumber;
        this._grid.itemsPerPage = res.itemsPerPage;
        this._grid.totalItems = res.totalItems;
        this._grid.totalPages = res.totalPages;
        this._grid.collectionOfGridItems = <Array<InvoiceObject>>(res.data);

        this._skeleton.skeletonGridLoader = true;
        this._skeleton.skeletonGridDataLoader = true;

        if (this._grid.collectionOfGridItems.length > 0) {
          this.collectionOfPaymentRun = this._grid.collectionOfGridItems.filter(item => item.status !== PaymentRunStatus.pending);
          this._grid.statusGrid = OpacityState.isVisible;
          this._grid.statusGridMessage = OpacityState.isHidden;
        } else {
          this._grid.statusGrid = OpacityState.isHidden;
          this._grid.statusGridMessage = OpacityState.isVisible;
        }
      },
      (err: RestResponse) => {
        this._meta.showNotification(err);
      }
    )
  }

  ngOnDestroy() {
    this._grid.clearData();
    this._skeleton.skeletonGridLoader = false;
    this._skeleton.skeletonGridDataLoader = false;
    this.subscriptionToTimezone.unsubscribe();
    this.subs.unsubscribe();
  }

  async ngOnInit() {
    try {
      let _isSubscribedToCompanyTimezone = await this.subscribeToCompanyTimezone();
      let _isSubscribedToCompanyCurrency = await this.subscribeToCompanyCurrency();
    } catch (error) {
      console.log('@@@error',error);
    }
  }

  subscribeToCompanyCurrency(){
    return new Promise((resolve, reject) => {
      this.subscriptionToCurrencyBase = this._shareData.currentCompanySettingsCurrencyBaseSource.subscribe(
        (data) => {
          this.companyCurrencyBase = data.currencyBase;
          resolve(true);
        },
        (err) => {
          reject(false);
        }
      );
    })
  }

  subscribeToCompanyTimezone(){
    return new Promise((resolve, reject) => {
      this.subscriptionToTimezone = this._shareData.currentCompanySettingsTimezone.subscribe(
        (data) => {
          this.companyTimezone = new CompanyTimezone().deserialize(data);
          resolve(true);
        },
        (err) => {
          reject(false);
        }
      );
    })
  }

  manuallyRerunPaymentRun(paymentRunId) {
    const dialogConfirmation = this._dialog.open(DialogConfirmationComponent, {
      panelClass: ['custom-mat-dialog'],
      data: {
        code: KeyName.manually_rerun_payment_run,
      },
    });
    dialogConfirmation.afterClosed().subscribe((resCode) => {
      if (resCode === KeyName.manually_rerun_payment_run) {
        this.settingsService.manuallyRerunCompanyPaymentRunByPaymentRunId(paymentRunId).subscribe((res: RestResponse) => {
            this._loader.stopPageLoader();
            this._meta.showNotification(res);
          },
          (err: any) => {
            this._loader.stopPageLoader();
            this._meta.showNotification(err);
          })
      }
    });
  }

}
